define([
    'jquery',
    'Handlebars',
    'handlebars-core',
    'pubsub'
], function ($, Handlebars, HandlebarsCore, pubsub) {

// Name the plugin
    var PLUGIN_IDENTIFIER = 'validationMessage',
        DEBUG = false;

// Create the function that will be bound to JQuery
    var vfdpPlugin = function (element, options) {
        this.element = element;
        this.options = options;
    };

// Define the plugin's prototype and defaults
    vfdpPlugin.prototype = {
        defaults: {
            'targetContainer': '.product-content-form-step-header.step-header',
            'template': 'html.validation-message.validation-message',
            'label': '',
            'icon': 'icon-error',
            'triggerEvent': 'PDP_ADD_TO_CART_UNSELECTED_SIZES',
            'selectionEvent': 'PDP_ADD_TO_CART_SELECTED'
        },

        /**
         * Initializes the plugin instance
         * @returns {Object} This plugin instance
         */
        init: function () {
            var self = this;

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER + 'Options');
            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );

            // Initialize events
            self.events();

            // Do any DOM manipulation or other setup
            self._build();

            // Allow JQuery-style chaining of the plugin
            return self;
        },

        /**
         * Modifies the DOM to support layout requirements
         **/
        _build: function () {
            var self = this;

            // do on-init DOM modifications here
            return self.loadAndCompileTemplate().done(function () {
                if (!self.$targetContainer) {
                    self.render(self.config);
                }
            });

        },

        /**
         * render()
         * Renders our Handlebars template.
         * @param {Object} data - the data you wish to render
         */
        render: function (data) {
            var self = this;
            self.$currentElement = $(self.element);
            self.$targetContainer = self.$currentElement;

            if (self.config.targetContainer) {
                self.$targetContainer = self.$targetContainer.find(self.config.targetContainer);
            }
            self.$targetContainer.after(self.compiledTemplate(data));
            self.$targetControl = self.$currentElement.find('.validation-message');
        },

        /**
         * Binds plugin events
         **/
        events: function () {
            var self = this;

            // create event listeners here
            $.pubsub('subscribe', self.config.triggerEvent, self.toggleMessage.bind(self));
            $.pubsub('subscribe', self.config.selectionEvent, self.selectEvent.bind(self));

        },

        toggleMessage: function (event, selectionObj) {
            var self = this;
            if( selectionObj.unselectedSizes.length === 0 ){
                self.$targetControl.addClass('hide');
            }
            else {
                var anyMatch = false;
                for(var i = 0; i < selectionObj.unselectedSizes.length; i++){
                    if( self.$currentElement[0] === selectionObj.unselectedSizes[i] ){
                        self.$targetControl.removeClass('hide');
                        anyMatch = true;
                        var firstUnselected = $(selectionObj.unselectedSizes[i]);
                        $('html, body').animate({
                            scrollTop: firstUnselected.offset().top - firstUnselected.outerHeight()
                        }, 700);
                        break;
                    }
                }
                if( anyMatch === false ){
                    self.$targetControl.addClass('hide');
                }
            }
        },

        selectEvent: function () {
            var self = this;
            if( self.$currentElement.first().hasClass('attribute-value-selected')){
                self.$targetControl.addClass('hide');
            }
        }

    };

// Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;
    vfdpPlugin.prototype = $.extend({}, HandlebarsCore, vfdpPlugin.prototype);

// Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function (options) {
        return this.each(function () {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if (!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };

});